import React, {useState, useEffect} from "react";

import {
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    InputGroup,
    Row,
    Col,
} from "reactstrap";

import helper from '../../services/helper.service';
import adminApi from '../../services/admin.service';
import session from '../../services/session.service';

function Login(props) {

    const [credentials, setCredentials] = useState({
        username: null,
        password: null
    });

    const login = () => {

        adminApi.login(credentials)
            .then((response) => {

            console.log("login reponse: ");
            console.log(response);
    
            if(response.status === 200){
                helper.showToast('Success', 'Successfully logged in.', 1);
                
                session.set('isLogin', true);
                const data = response.data;
                if(data.username === 'admin'){
                    session.set('isAdmin', true);
                } else {
                    session.set('isAdmin', false);
                }

                session.set('clubInfo', {
                    clubId: data.id,
                    clubName: data.name,
                    clubLogoUrl: data.logo_url,
                    clubUserName: data.username,
                    latitude: data.latitude,
                    longitude: data.longitude,
                    existTurn: data.turn == "false" ? false : true,
                    tee_start: data.tee_start, 
                    tee_end: data.tee_end, 
                    tee_duration: data.tee_duration,
                    map_marker_label: data.map_marker_label,
                    notification_start: data.notification_start,
                    notification_end: data.notification_end,
                    has_27_holes: data.has_27_holes,
                    name_of_course_a: data.name_of_course_a,
                    name_of_course_b: data.name_of_course_b,
                    name_of_course_c: data.name_of_course_c,
                    auto_game_start: data.auto_game_start,
                    auto_game_end: data.auto_game_end,
                    facility_id: data.facility_id,
                });
        
                window.location.reload();
                
    
            }else {
                session.set('isLogin', false);
                helper.showToast('Error', 'Failed to log in.', 3);
            }
        })
        .catch((error) => {
            console.log("err: ", error);
            session.set('isLogin', false);
            helper.showToast('Error', 'Invalid auth', 3);
        })
    }

    return (
        <>
             <Col lg="5" md="7">
                <Card className="bg-secondary shadow border-0">
                
                    <CardBody className="px-lg-5 py-lg-5">
                        <div className="text-center text-muted mb-4">
                            <small>Sign in with credentials</small>
                        </div>
                        <Form role="form">
                        <FormGroup className="mb-3">
                            <InputGroup className="input-group-alternative">
                        
                            <Input
                                placeholder="User name"
                          
                                autoComplete="new-email"
                                onChange={(e) => setCredentials({...credentials, username: e.target.value})}
                            />
                            </InputGroup>
                        </FormGroup>
                        <FormGroup>
                            <InputGroup className="input-group-alternative">
                        
                            <Input
                                placeholder="Password"
                                type="password"
                                onChange={(e) => setCredentials({...credentials, password: e.target.value})}
                                
                            />
                            </InputGroup>
                        </FormGroup>
                      
                        <div className="text-center">
                            <Button className="my-4" color="primary" type="button"
                            onClick={() => login()}>
                            Sign in
                            </Button>
                        </div>
                        </Form>
                    </CardBody>
                </Card>
              
            </Col>
        </>
    )
}

export default Login;